import React from 'react';
import SwipeableViews from 'react-swipeable-views';

import {
  ContentWrapper,
  DrawingGreen,
  DrawingYellow,
  DrawingBlue,
  TextWrapperGreen,
  TextWrapperYellow,
  TextWrapperBlue,
} from './style';
import FilterDrawing from '../../images/filterDrawing';
import ResponsiveDrawing from '../../images/responsiveDrawing';
import CustomerDrawing from '../../images/customerDrawing';

const IntelligentSearch = () => (
  <ContentWrapper>
    <DrawingGreen>
      <FilterDrawing width={150} height={150} />
    </DrawingGreen>
    <TextWrapperGreen>
      <p>
        Unser Online Shop ist mit einer sinvollen und in <span>Echtzeit</span>{' '}
        funtionierenden <span>Filterfunktion</span> ausgestattet. Dadurch kommen
        Sie in <span>kürzester Zeit</span> zur Ihrer gewünschten Auswahl.
      </p>
    </TextWrapperGreen>
  </ContentWrapper>
);

const Responsive = () => (
  <ContentWrapper>
    <DrawingYellow>
      <ResponsiveDrawing width={150} height={150} />
    </DrawingYellow>
    <TextWrapperYellow>
      <p>
        Verwenden Sie unseren Online Shop sowohl am <span>Desktop</span> als
        auch an Ihren <span>mobilen Endgeräten</span>. Dank unseres
        <span> Cloud basierten </span> Warenkorbs können Sie immer und überall
        einkaufen.
      </p>
    </TextWrapperYellow>
  </ContentWrapper>
);

const CustomerFriendly = () => (
  <ContentWrapper>
    <DrawingBlue>
      <CustomerDrawing width={150} height={150} />
    </DrawingBlue>
    <TextWrapperBlue>
      <p>
        Damit Sie unseren Online Shop auch mit <span>Kunden</span> besuchen
        können, sind Preise einzelner Fassungen{' '}
        <span>ein- und ausblendbar</span>. Dank der einfach zu bedienenden{' '}
        <span>Suchfunktion</span> finden Sie gemeinsam mit Ihrem Kunden die
        passende Fassung.
      </p>
    </TextWrapperBlue>
  </ContentWrapper>
);

const AdvantagesSlider = () => (
  <SwipeableViews
    enableMouseEvents
    containerStyle={{
      height: '100%',
    }}
    slideStyle={{
      width: '100%',
      height: '100%',
    }}
    style={{
      width: '100%',
      height: '75%',
      maxWidth: '760px',
    }}
  >
    <Responsive />
    <IntelligentSearch />
    <CustomerFriendly />
  </SwipeableViews>
);

export default AdvantagesSlider;



// WEBPACK FOOTER //
// ../shop_main/components/login/advantages.js